import _ from 'lodash';

export const getEntitySelectorHelperMessage = ({
  hasOptions,
  selectedOption,
  helperText,
  emptyText,
}) => {
  if (!hasOptions) {
    return emptyText;
  }

  return _.isNil(selectedOption) ? helperText : null;
};
